import type { SVGAttributes } from 'react';
import styled from 'styled-components';
import { MARKET_BRAND_LOGOS, hasMarketBrandLogo } from './brand';

const Wrapper = styled.svg`
  vertical-align: middle;
`;

/**
 * Renders a market's full-color logo. Returns nothing for markets without one, so callers stay
 * responsible for choosing their own fallback.
 */
export const MarketBrandLogo = ({
  market,
  size = 24,
  title,
  ...props
}: { market?: string; size?: number | string; title?: string } & SVGAttributes<SVGElement>) => {
  if (!hasMarketBrandLogo(market)) {
    return null;
  }
  const Logo = MARKET_BRAND_LOGOS[market];

  return (
    <Wrapper width={size} height={size} {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      {title && <title>{title}</title>}
      <Logo />
    </Wrapper>
  );
};
